module.exports = __webpack_public_path__ + "static/img/logo@2x.a717827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/logo@2x.png
// module id = qXjJ
// module chunks = 70